var _circle, _path, _path2, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEventButtonSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#002648"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 19.2725H12V33.818H34V19.2725ZM10 19.2725V14.1816V12.1816H12H34H36V14.1816V19.2725V33.818V35.818H34H12H10V33.818V19.2725Z",
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5994 30L20.7794 26.68C20.9594 26.4867 21.1127 26.3067 21.2394 26.14C21.3661 25.9733 21.4627 25.8067 21.5294 25.64C21.5961 25.4733 21.6294 25.3 21.6294 25.12C21.6294 24.9933 21.6061 24.87 21.5594 24.75C21.5127 24.63 21.4427 24.5233 21.3494 24.43C21.2561 24.3367 21.1427 24.2633 21.0094 24.21C20.8761 24.15 20.7227 24.12 20.5494 24.12C20.3027 24.12 20.0894 24.18 19.9094 24.3C19.7361 24.4133 19.5994 24.5767 19.4994 24.79C19.4061 25.0033 19.3594 25.25 19.3594 25.53H17.9594C17.9594 25.03 18.0594 24.58 18.2594 24.18C18.4594 23.78 18.7527 23.4633 19.1394 23.23C19.5327 22.99 20.0127 22.87 20.5794 22.87C20.9994 22.87 21.3661 22.9367 21.6794 23.07C21.9994 23.1967 22.2627 23.3667 22.4694 23.58C22.6827 23.7867 22.8394 24.0167 22.9394 24.27C23.0461 24.5233 23.0994 24.7767 23.0994 25.03C23.0994 25.4033 23.0094 25.7533 22.8294 26.08C22.6494 26.4067 22.4127 26.7033 22.1194 26.97L20.2994 28.69H23.2294V30H17.5994ZM24.3985 24.82V23.53L27.4685 22.88V30H26.0785V24.38L24.3985 24.82Z",
    fill: "#FF0000"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 1,
    height: 4,
    fill: "#FF0000"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 9,
    width: 1,
    height: 4,
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventButtonSelected);
export default __webpack_public_path__ + "static/media/event-button-selected.c64255ef7bd8212d85b5358aca477e5f.svg";
export { ForwardRef as ReactComponent };